const CHART_EXPORTING = {
  chart_csv: [
    // 'companyProduct',
    // 'HistoricalRegionalRevenueTrend',
    // 'ProductMix',
  ],
  menu_items_basic: [
    'showMaxMin',
    'drawHorizLine',
    'drawDiagLine',
    'addCaption',
    'separator',
  ],
  menu_items_display: [
    'viewFullscreen',
  ],
  menu_items_exporting: [
    'downloadPNG',
  ],
  menu_items_exporting_csv: [
    'downloadCSV',
  ],
  menu_items_chart: [
    'showLbl',
    'calcAverage',
    'calcSum',
    'calcSD',
    'calcGrowthValue',
    'calcGrowthRate',
    'calcCompoundAnnualGrowthRate',
    'calcProportion',
  ],
  menu_items_k_line: [
    'calcKLineAverage',
    'calcKLineGrowthRate',
  ],
  menu_items_reuters: [
    'selectAll',
    'deselectAll',
    'editStocks',
    'combine', // 產業合併
    'showAllData',
    'switchChartType',
    'calcGrowthRate',
    'calcCompoundAnnualGrowthRate',
    'showLbl',
    'calcProportion',
  ],

  menu_items_calc: [
    'clear',
    'reset',
    'addCaption',
    'separator',
    'downloadPNG',
  ],
  menu_items_polar: [
    'viewFullscreen',
    'addCaption',
    'separator',
    'downloadPNG',
  ],
  style: {
    display: 'block',
    color: '#ffa500',
    fontSize: '14px',
    fontWeight: '400',
  },
}


export { CHART_EXPORTING }
